import React from 'react'
import styled, { css } from 'styled-components'
import { string, bool } from 'prop-types'
import Portal from 'components/Portal'
import { stripUnit, rgba } from 'polished'

import { white, greyDark, borderColor } from 'styles/colors'
import * as spacing from 'styles/spacing'
import { animationTime, animationCurve } from 'styles/global'
import { media } from 'styles/media'
import Icon from 'components/Icon'

const Container = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  bottom: ${spacing.large};
  left: 50%;
  z-index: 500;
  background-color: ${white};
  opacity: 0;
  visibility: hidden;
  border-radius: ${spacing.xLarge};
  border: 1px solid ${borderColor};
  transform: translateY(${spacing.tiny}) translateX(-50%);
  transition: opacity ${animationTime} ${animationCurve}, visibility ${animationTime} ${animationCurve},
    transform ${animationTime} ${animationCurve};
  box-shadow: 0 2px 34px 0 ${rgba(greyDark, 0.1)};
  white-space: nowrap;

  ${props =>
    props.visible &&
    css`
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%);
    `}

  ${media.large`
    bottom: ${spacing.xLarge};
  `};
`

const Inner = styled.div`
  padding: ${stripUnit(spacing.small) * 1.5 + 'px'} ${stripUnit(spacing.medium) * 1.5 + 'px'};

  ${media.large`
    padding: ${stripUnit(spacing.small) * 1.75 + 'px'} ${spacing.xLarge};
  `};
`

const Toast = ({ message, icon, visible, ...rest }) => (
  <Portal selector={'toast-portal'}>
    <Container visible={visible} {...rest}>
      {icon && <Icon icon={icon} />}
      <Inner>
        <p>{message}</p>
      </Inner>
    </Container>
  </Portal>
)

Toast.propTypes = {
  message: string.isRequired,
  icon: string,
  visible: bool
}

export default Toast
